export default __webpack_public_path__ + "static/char-v-40-17aa75934d4b9e290bf46a64c7c7666d.webp";